import { commonFetch } from "./fetch";

// 获取首页banner列表
export function getBannerList(
  data: HomeBannerParams
): Promise<HomeBannerData> {
  return commonFetch(
    "/crm-dms/v1/carouselPicture/carouselPicture/findByCarouselPictureCustomerPageDto",
    true,
    data
  );
}

const homeApi = {
  getBannerList,
}

export default homeApi;
